import { render, staticRenderFns } from "./fillRegisterMessage.vue?vue&type=template&id=2d1c5aa2&scoped=true&"
import script from "./fillRegisterMessage.vue?vue&type=script&lang=ts&"
export * from "./fillRegisterMessage.vue?vue&type=script&lang=ts&"
import style0 from "./fillRegisterMessage.vue?vue&type=style&index=0&id=2d1c5aa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1c5aa2",
  null
  
)

export default component.exports